import React, { useState, useEffect, useContext } from 'react';
import { useRecoilState } from 'recoil';
import { btnColor, mainBlueColor, userPlanId } from '../../../GlobalState';
import { TInpteSelectItem } from '../../../types/common';
import { MoveFolderModal } from './MoveFolderModal';
import { TFile, TPicture } from '../../../types/cloudStorage/CloudFileList';
import { Button } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import CreateNewFolderIcon from '@material-ui/icons/CreateNewFolder';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { AuthInfoContext } from '../../../AuthContextProvider';
import { ROLE } from '../../../const/Const';

type Tprops = {
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setDeleteModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  downloadZip: any;
  moveFolder: any;
  folderSelectList: TInpteSelectItem[];
  getSelectedLists: any;
  name: string;
  selectFiles: TFile[] | TPicture[];
  getValues?: any;
};

// ボタンエリア
export const ButtonField: React.FC<Tprops> = (props: Tprops) => {
  const {
    setModalOpen,
    setDeleteModalOpen,
    downloadZip,
    moveFolder,
    folderSelectList,
    getSelectedLists,
    name,
    selectFiles,
    getValues
  } = props;

  const history: any = useHistory();

  // カラー設定
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);

  // モーダルオープン
  const [moveFileModalOpen, setMoveFileModalOpen] = useState(false);

  const [dispMoveBtn, setDispMoveBtn] = useState<boolean>(false);

  const [disableBtn, setDisableBtn] = useState<boolean>(true);

  // ボタンのサイズ調整
  const theme = useTheme();
  const isWideScreen = useMediaQuery(theme.breakpoints.up('md'));

  useEffect(() => {
    if (selectFiles.length == 0) {
      setDisableBtn(true);
    } else {
      setDisableBtn(false);
    }
  }, [selectFiles]);

  return (
    <div style={{ padding: 15, backgroundColor: '#FFFFFF', borderRadius: 5 }}>
      <div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center'
          }}
        >
          {/* ここから右寄せの箱の中 */}
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'start',
              alignItems: 'center',
              overflow: 'hidden'
            }}
          >
            {/* 縦並びの箱をつくる */}

            {/* スマホサイズの新規フォルダ追加ボタン */}
            {!isWideScreen && (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'end',
                  alignItems: 'center',
                  borderBottom: '1px solid #cfcfcf'
                }}
              >
                <Button
                  style={{
                    backgroundColor: '#007dff',
                    marginBottom: 5,
                    maxHeight: 40
                  }}
                  onClick={() => setModalOpen(true)}
                  variant='contained'
                  color='secondary'
                >
                  <CreateNewFolderIcon style={{ marginRight: 8 }} />
                  <span style={{ marginLeft: 8 }}>新規フォルダ追加</span>
                </Button>
              </div>
            )}

            {/* 要素１ */}
            {selectFiles.length !== 0 && (
              <div style={{ color: 'red', marginRight: 24 }}>
                {selectFiles.length}件選択中
              </div>
            )}
            {/* 要素２ */}
            <div style={{ fontWeight: 'bold', marginRight: 16 }}>
              選択した{name}を
            </div>

            <div style={{ display: 'flex' }}>
              {/* 横並びの箱をつくる */}
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  paddingRight: 10,
                  marginRight: 14,
                  borderRight: isWideScreen ? '1px solid #cfcfcf' : 'none'
                }}
              >
                {/* ボタンの箱はじまり */}

                {/* ボタン１ */}
                <Button
                  style={{
                    backgroundColor: buttonColor,
                    color: '#fff',
                    marginRight: 10,
                    marginBottom: 5
                  }}
                  variant='contained'
                  color='secondary'
                  onClick={() => setDeleteModalOpen(true)}
                  disabled={disableBtn}
                >
                  <DeleteIcon />
                  削除
                </Button>

                {/* ボタン２ */}
                <Button
                  style={{
                    backgroundColor: buttonColor,
                    color: '#fff',
                    marginRight: 10,
                    marginBottom: 5
                  }}
                  variant='contained'
                  color='secondary'
                  onClick={() => setMoveFileModalOpen(true)}
                  disabled={disableBtn}
                >
                  <svg
                    width='20'
                    height='20'
                    viewBox='0 0 20 20'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M11.6667 14.1665H15V11.6665L19.1667 15.4165L15 19.1665V16.6665H11.6667V14.1665ZM10.8334 7.49984H15.4167L10.8334 2.9165V7.49984ZM5.00004 1.6665H11.6667L16.6667 6.6665V10.2832C16.1417 10.0998 15.5834 9.99984 15 9.99984C13.674 9.99984 12.4022 10.5266 11.4645 11.4643C10.5268 12.402 10 13.6738 10 14.9998C10 16.2832 10.4834 17.4498 11.275 18.3332H5.00004C4.07504 18.3332 3.33337 17.5832 3.33337 16.6665V3.33317C3.33337 2.89114 3.50897 2.46722 3.82153 2.15466C4.13409 1.8421 4.55801 1.6665 5.00004 1.6665Z'
                      fill='white'
                    />
                  </svg>
                  <span style={{ marginLeft: 8 }}>移動</span>
                </Button>
                <MoveFolderModal
                  moveFolder={moveFolder}
                  modalOpen={moveFileModalOpen}
                  setModalOpen={setMoveFileModalOpen}
                  folderList={folderSelectList}
                  getSelectedLists={getSelectedLists}
                  name={name}
                />

                {authInfo?.role != ROLE['OUTSIDE_PARTNER'] && (
                  <>
                    {/* ボタン３ */}
                    {getValues && (
                      <Button
                        style={{
                          backgroundColor: buttonColor,
                          color: '#fff',
                          marginRight: 10,
                          marginBottom: 5
                        }}
                        variant='contained'
                        color='secondary'
                        onClick={() =>
                          history.push('/create-ledger', {
                            constructId: getValues('construct_id')
                          })
                        }
                        disabled={disableBtn}
                      >
                        写真台帳作成
                      </Button>
                    )}

                    {/* ボタン４ */}
                    <Button
                      style={{
                        backgroundColor: buttonColor,
                        color: '#fff',
                        marginRight: 10,
                        marginBottom: 5
                      }}
                      variant='contained'
                      color='secondary'
                      onClick={downloadZip}
                      disabled={disableBtn}
                    >
                      <GetAppIcon />
                      ダウンロード
                    </Button>
                  </>
                )}
              </div>
              {/* ボタンの箱おわり */}

              {/* スマホ以外の新規フォルダ追加ボタン */}
              {isWideScreen && (
                <Button
                  style={{
                    backgroundColor: '#007dff',
                    marginBottom: 5
                  }}
                  onClick={() => setModalOpen(true)}
                  variant='contained'
                  color='secondary'
                >
                  <CreateNewFolderIcon style={{ marginRight: 8 }} />
                  <span style={{ marginLeft: 8 }}>新規フォルダ追加</span>
                </Button>
              )}
            </div>
            {/* 横並びの箱おわり */}
          </div>
          {/* 縦並びの箱おわり */}
        </div>
        {/* 右寄せの箱ここまで */}
      </div>
    </div>
  );
};
